export const MOVE_CHESS = 'MOVE_CHESS'

export const DISPATCH_CHESS = 'DISPATCH_CHESS'

export const WITHDRAW_CHESS = 'WITHDRAW_CHESS'

export const BUY_CHESS = 'BUY_CHESS'

export const SELL_CHESS = 'SELL_CHESS'

export const REFRESH_SHOP = 'REFRESH_SHOP'

export const TOGGLE_LOCKED = 'TOGGLE_LOCKED'

export const INCREASE_ROUND = 'INCREASE_ROUND'

export const GAIN_EXP = 'GAIN_EXP'

export const RESET = 'RESET'
